import { PostSearch, PostSearchFilters } from '@/type';
import postSearchRepository from '../search/post-search-repository';

const FLAGGING_SEARCH_TAG = 'flagging';

export async function findFlaggingSearch(clientId: number): Promise<PostSearch> {
  const filters:PostSearchFilters = { tags: [FLAGGING_SEARCH_TAG] };
  const result = await postSearchRepository.findAll(clientId, filters);
  if (result.items.length === 1) return result.items[0];
  throw new Error(`No flagging search found for client ${clientId}`);
}
